import type { AICommand } from '../hooks/useAICommands';

/**
 * Expand a leading slash-command literal (e.g. "/create-objective add booming")
 * back to its natural-language prompt template before sending, preserving any
 * text the user typed after the command. Only an exact leading-command match
 * expands — ordinary text starting with "/" is returned unchanged.
 */
export const expandSlashCommand = (
  text: string,
  commands: Pick<AICommand, 'command' | 'promptTemplate'>[] | undefined
): string => {
  if (!text.startsWith('/') || !Array.isArray(commands)) {
    return text;
  }
  for (const cmd of commands) {
    if (text === cmd.command) {
      return cmd.promptTemplate;
    }
    const prefix = `${cmd.command} `;
    if (text.startsWith(prefix)) {
      const rest = text.slice(prefix.length).trim();
      return rest ? `${cmd.promptTemplate} ${rest}` : cmd.promptTemplate;
    }
  }
  return text;
};
